import React from "react";
import PropTypes from "prop-types";

import Tabs from '@mui/material/Tabs';
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

/**
 * Renders a st of tabs representing a set of data.
 * @param {number|string} id
 * @param {array} tabbedData
 * @param {number} activeTabIndex
 * @param {function} handleTabChange
 * @param {string} tabIdProp
 * @param {string} tabLabelProp
 * @return {*}
 * @constructor
 */
const DataTabs = ({id, tabbedData, activeTabIndex, handleTabChange, tabIdProp, tabLabelProp}) => (
    <Box
        id={id && `${id}-tabs`}
        sx={{
            borderBottom: 1,
            borderColor: 'divider',
            mb: 5
        }}
    >
        <Tabs
            value={activeTabIndex}
            onChange={handleTabChange}
        >
            {
                tabbedData.map((eachTab, tabIndex) => (
                    <Tab
                        key={eachTab[tabIdProp] || tabIndex}
                        label={eachTab[tabLabelProp]}
                    />)
                )
            }
        </Tabs>
    </Box>
);
DataTabs.propTypes = {
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    tabbedData: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
        PropTypes.func.isRequired
    ]).isRequired,
    activeTabIndex: PropTypes.number.isRequired,
    handleTabChange: PropTypes.func.isRequired,
    tabLabelProp: PropTypes.string.isRequired,
    tabIdProp: PropTypes.string
};

export default DataTabs;
